// Stylesheet
import "./NavMenu.css";

import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, withRouter } from "react-router-dom";

import { TopLevelRoutes } from "../../config/routes";
// Assets
import Icons from "../Utilities/Icons";

const NavMenuComponent: React.FC = (props: any) => {
  const { t } = useTranslation();
  const { NavIcons, NavIconsAct } = Icons;

  // Effects
  React.useEffect(() => {
    const currentPath = window.location.pathname.replace(/^\//, "");
    switch (true) {
      case /settings\//.test(currentPath):
        const settingsPath = currentPath.replace("settings", "").replace(/\//, "");
        document.title = `PT Flow | ${settingsPath.replace(
          settingsPath[0],
          settingsPath[0].toUpperCase()
        )}`;
        break;
      case /clients\/add/.test(currentPath):
        document.title = "PT Flow | Clients | Add";
        break;
      case /clients\/edit/.test(currentPath):
        document.title = "PT Flow | Clients | Edit";
        break;
      case /clients\//.test(currentPath):
        document.title = `PT Flow | Clients`;
        break;
      case /exercises\/add/.test(currentPath):
        document.title = "PT Flow | Exercises | Add";
        break;
      case /exercises\/edit/.test(currentPath):
        document.title = "PT Flow | Exercises | Edit";
        break;
      case /exercises\//.test(currentPath):
        document.title = "PT Flow | Exercises";
        break;
      case /workouts\/add/.test(currentPath):
        document.title = "PT Flow | Workouts | Add";
        break;
      case /workouts\/edit/.test(currentPath):
        document.title = "PT Flow | Workouts | Edit";
        break;
      case /workouts\//.test(currentPath):
        document.title = "PT Flow | Workouts";
        break;
      case /[aA-zZ]/.test(currentPath):
        document.title = `PT Flow | ${currentPath.replace(
          currentPath[0],
          currentPath[0].toUpperCase()
        )}`;
        break;
      default:
        document.title = "PT Flow";
        break;
    }
  });

  let menuListItems: JSX.Element[] = [];

  TopLevelRoutes.forEach((route, i) => {
    const tag = route === "/" ? "dashboard" : `${route}`.replace("/", "");
    const pathName = new RegExp(tag);
    const active = pathName.test(props.location.pathname);
    const menu = (
      <li key={i} className={`list-item ${active ? "active" : ""}`}>
        <NavLink exact to={route} title={t(`${tag}`).toUpperCase()}>
          <img alt={t(`${tag}`)} src={active ? NavIconsAct[i] : NavIcons[i]} />
          <span>{t(`${tag}`)}</span>
        </NavLink>
      </li>
    );
    menuListItems = [...menuListItems, menu];
  });
  if (props.location.pathname === "/") {
    menuListItems[0] = (
      <li key={0} className={`list-item active`}>
        <NavLink exact to="/" title={"dashboard".toUpperCase()}>
          <img alt={t("dashboard")} src={NavIconsAct[0]} />
          <span>{t("Dashboard")}</span>
        </NavLink>
      </li>
    );
  }

  return (
    <div id="NavMenu">
      <ul className="list-group">{menuListItems}</ul>
    </div>
  );
};

export default withRouter(NavMenuComponent);
